import Loading from './src/main'

export default Loading



// WEBPACK FOOTER //
// ./src/components/loading/index.js